import { FC } from "react";
import PageTemplate from "../PageTemplate";
import SubscriptionPage from "./SubscriptionPage";

const Subscription: FC = () => {
    return <PageTemplate Page={SubscriptionPage} />;
};

export default Subscription;
